import { createContext } from 'react'
import { ZoomMakerFrame, ZoomMakerStatus } from '../types'

type ZoomMakerDownloadContextProps = {
    frames: ZoomMakerFrame[]
    status: ZoomMakerStatus
    hasDownloaded: boolean
    setStatus: (status: ZoomMakerStatus) => void
    onDownload: () => void
    onUpload: () => void
}

export const ZoomMakerDownloadContext = createContext({} as ZoomMakerDownloadContextProps)
